import { render, staticRenderFns } from "./PendingReplacements.vue?vue&type=template&id=7306cad8&"
import script from "./PendingReplacements.vue?vue&type=script&lang=js&"
export * from "./PendingReplacements.vue?vue&type=script&lang=js&"
import style0 from "./PendingReplacements.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports